/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { gql } from 'graphql-tag';
/* AppSync */
import appsyncclient from '../../api/AppSync';
/* GraphQL */

import makeData from '../mock/makeData';
import avatarSrc from '../mock/img/avatar.jpg'
const initialState = {
  allCase: [],
  telePathologists: []
};
/*******************************************************************************
 * main
 ******************************************************************************/
export function allcaseReducer(state = initialState, action) {
  switch (action.type) {
    case 'allcase/TelePathologistsLoaded': {
      return { ...state, telePathologists: action.payload };
    }

    case 'allcase/AllCaseLoaded': {
      return { ...state, allCase: action.payload };
    }

    default:
      return state;
  };
};

// Thunk function
export function fetchGetAllCase(search) {
  return async dispatch => {
    try {
      // const response = await appsyncclient.query({
      //   query: gql(queryGetAllCaseList),
      //   variables: { user_id:  }
      // });
      const response = {
        data: {
          getAllcase: makeData(10, 5)
        }
      }
      console.log('getAllcase search: ' + search)

      dispatch({ type: 'allcase/AllCaseLoaded', payload: response.data.getAllcase });
    } catch (error) {
      console.log('fetchGetAllCase error: ', error);
    };
  }
};

export function fetchGetTelePathologist(search) {
  return async dispatch => {
    try {
      // const response = await appsyncclient.query({
      //   query: gql(queryGetAllCaseList),
      //   variables: { user_id:  }
      // });
      const response = makeData(10)
      console.log(response)
      dispatch({ type: 'allcase/TelePathologistsLoaded', payload: response });
    } catch (error) {
      console.log('fetchGetTelePathologist error: ', error);
    };
  }
};